export function userlogo(name) {
  let userLogo = name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();
  return userLogo === "" ? "AB" : userLogo;
}

export const RenderIf = ({ children, isTrue }) => {
  return isTrue ? children : null;
};

export function sessionRoleDisplay(data) {
  return data.join(', ')
}

export function validINRCurrency(e) {
  if (e != null) {
    let numStr = e.toString().split(".");
    let result = [];
    let integerLength = numStr[0].length;

    // Handle the last three digits
    if (integerLength > 3) {
      result.push(numStr[0].slice(-3));
      numStr[0] = numStr[0].slice(0, -3);
    }
    // Insert commas for every two digits
    for (let i = numStr[0].length; i > 0; i -= 2) {
      result.unshift(numStr[0].slice(Math.max(0, i - 2), i));
    }
    let integerPart = result.join(',');
    return numStr[1] ? integerPart + '.' + numStr[1] : integerPart;
  } else {
    return "";
  }
}

export const formatAmountLabel = (val) => {
  const num = Number(val);
  if (!num) return "";

  const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

  const toWords = (n) => {
    if (n === 0) return "";
    if (n < 20) return ones[n];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
    if (n < 1000) return ones[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " and " + toWords(n % 100) : "");
    if (n < 100000) return toWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + toWords(n % 1000) : "");
    if (n < 10000000) return toWords(Math.floor(n / 100000)) + " Lacs" + (n % 100000 ? " " + toWords(n % 100000) : "");
    return toWords(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + toWords(n % 10000000) : "");
  };

  return toWords(Math.round(num));
};

